import { toMapStateToLinkProps } from '@peloton/external-links/withExtHrefs';
import { Links } from '@peloton/links';
import { useReduxState } from '@engage/redux/hooks';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';

export const useReferralsUrlWithSource = (type: 'card' | 'nav') => {
  const { asPath } = useRouter();
  const { referralsHref } = useReduxState(
    toMapStateToLinkProps({ referralsHref: Links.referrals }),
  );
  return `${referralsHref}?source=${asPath}-${type}`;
};
